var map = {
	"./de-CH.christmas.json": 9899,
	"./de-CH.faq.json": 1415,
	"./de-CH.json": 2919,
	"./de-CH.materials.json": 1935,
	"./de-CH.oRingErrorTypes.json": 2067,
	"./en-CH.christmas.json": 123,
	"./en-CH.json": 2723,
	"./en-CH.materials.json": 5669,
	"./en-CH.oRingErrorTypes.json": 4805,
	"./fr-CH.christmas.json": 4307,
	"./fr-CH.json": 747,
	"./fr-CH.materials.json": 4723,
	"./fr-CH.oRingErrorTypes.json": 7800,
	"./it-CH.json": 5066,
	"./it-CH.materials.json": 482,
	"./it-CH.oRingErrorTypes.json": 8404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3251;